// Layout.js
import React from "react";
import PathNotifier from "./PathNotifier";
import ScrollToTop from "./ScrollToTop";

const Layout = ({ children }) => {
  return (
    <>
      <PathNotifier />
      <ScrollToTop />
      {children}
    </>
  );
};

export default Layout;
